import { API_BASE, getAuthHeaders } from './config';

export type Author = {
    id: string;
    first_name?: string;
    last_name?: string;
    name?: string;
    bio?: string;
    birth_date?: string | null;
    country?: string | null;
    created_by?: string | null;
    created_by_name?: string | null;
    last_edited_by?: string | null;
    last_edited_by_name?: string | null;
    last_edited_at?: string | null;
};

export async function fetchAllAuthors() {
    const res = await fetch(`${API_BASE}/authors`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json();
}

export const searchAuthors = async (query: string) => {
    const res = await fetch(`${API_BASE}/authors/search?q=${encodeURIComponent(query)}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
};

export async function searchAuthorsApi(q: string) {
    return searchAuthors(q);
}

export async function getAuthorWithWorks(id: string) {
    const res = await fetch(`${API_BASE}/author/${id}`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json();
}

export async function createAuthor(payload: Partial<Author>) {
    const res = await fetch(`${API_BASE}/authors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export async function updateAuthor(id: string, payload: Partial<Author>) {
    const res = await fetch(`${API_BASE}/authors/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export async function deleteAuthor(id: string) {
    const res = await fetch(`${API_BASE}/authors/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}
